import React, { ReactElement } from 'react';

import { LegacyCheckbox as Checkbox } from '@videoblocks/storywind';

export interface MyFoldersEnterpriseControlsPropTypes {
  showingPrivateFolders: boolean;
  onTogglePublicPrivateFolders: () => void;
  showingOnlyOwnedFolders: boolean;
  onToggleOnlyOwnedFolders: () => void;
}

const MyFoldersEnterpriseControls = ({
  showingPrivateFolders,
  onTogglePublicPrivateFolders,
  showingOnlyOwnedFolders,
  onToggleOnlyOwnedFolders,
}: MyFoldersEnterpriseControlsPropTypes): ReactElement => {
  const activeClasses =
    'active bg-blue-500 text-white font-bold cursor-default';

  return (
    <>
      <div className="inline-block text-sm bg-white border border-solid border-gray-400 rounded">
        <div
          role="button"
          tabIndex={0}
          className={`rounded-l inline-block py-4 px-6 ${
            showingPrivateFolders ? activeClasses : 'cursor-pointer'
          }`}
          onClick={() =>
            !showingPrivateFolders && onTogglePublicPrivateFolders()
          }
          onKeyDown={() =>
            !showingPrivateFolders && onTogglePublicPrivateFolders()
          }
        >
          Private Folders
        </div>
        <div
          role="button"
          tabIndex={0}
          className={`rounded-r inline-block py-4 px-6 ${
            showingPrivateFolders ? 'cursor-pointer' : activeClasses
          }`}
          onClick={() =>
            showingPrivateFolders && onTogglePublicPrivateFolders()
          }
          onKeyDown={() =>
            showingPrivateFolders && onTogglePublicPrivateFolders()
          }
        >
          Shared Folders
        </div>
      </div>

      {!showingPrivateFolders && (
        <span className="ml-4">
          <Checkbox
            value={showingOnlyOwnedFolders}
            onChange={onToggleOnlyOwnedFolders}
          />{' '}
          Only see shared folders you created
        </span>
      )}
    </>
  );
};

export default MyFoldersEnterpriseControls;
